import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import PropTypes from "prop-types";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import OpenIcon from "@material-ui/icons/OpenInNew";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import SendIcon from "@material-ui/icons/Send";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import PieChartIcon from "@material-ui/icons/PieChart";

import { confirmAlert } from "react-confirm-alert";
import { getEntitiesArray } from "../reducers/entitiesReducer";
import notificationActions from "../containers/general/notification/NotificationsManager/actions";
import popupActions from "../containers/general/popup/PopupsManager/actions";
import cacheActions from "../actions/cacheActions";
import DefaultTable from "../containers/general/conf-table/ConfTable";
import {
  infoColor,
  dangerColor,
  purpleColor,
  brownColor,
  primaryColor,
} from "../assets/jss/material-dashboard-pro-react";

import "react-confirm-alert/src/react-confirm-alert.css";
import "../assets/scss/react-confirm-alert/react-confirm-alert.css";
import { startImpersonation } from "utils/impersonation";
import { store } from "store";
import authActions from "actions/authActions";
import ciApi from "services/ciApi";
import { yellow } from "@material-ui/core/colors";

const generateEntityTable = ({
  entityPluralString,
  entityActions,
  editorRoutePath,
  operations,
  pathId,
  editOperation,
  deleteOperation,
  openOperation,
  openLinkOperation,
  forceExecutionOperation,
  forceExecutionRoutePath,
  openRoutePath,
  manageOperation,
  copyFiSwapSuggestionTextOperation,
  manageRoutePath,
  walletBalancingOperation,
  walletBalancingRoutePath,
  walletPositionOperation,
  walletPositionRoutePath,
  ...otherProps
}) =>
  connect((state) => ({
    entities: getEntitiesArray(entityPluralString)(state),
  }))(
    class extends Component {
      static propTypes = {
        dispatch: PropTypes.func.isRequired,
        entities: PropTypes.array.isRequired,
      };

      state = {
        id: `${Math.random()}`,
      };

      defaultOperations = [
        {
          title: "Editar",
          content: (
            <EditIcon style={{ fontSize: "18px" }} nativeColor={infoColor} />
          ),
          execute: (row) =>
            this.props.dispatch(push(`${editorRoutePath}/${row.id}`)),
        },
        {
          title: "Excluir",
          content: (
            <CloseIcon style={{ fontSize: "18px" }} nativeColor={dangerColor} />
          ),
          execute: (row) => this.confirmDelete(row.id),
        },
      ];

      getOperations = () => {
        if (operations) {
          return operations;
        }

        const ops = [];

        if (copyFiSwapSuggestionTextOperation) {
          ops.push({
            title: "Copiar texto da sugestão",
            content: (
              <FileCopyIcon
                style={{ fontSize: "18px" }}
                nativeColor={infoColor}
              />
            ),
            execute: (row) => {
              const text = row.suggestionText;
              if (text) {
                navigator.clipboard.writeText(text);
                this.props.dispatch(
                  notificationActions.showNotification(
                    "Texto copiado para a área de transferência.",
                    "success",
                  ),
                );
              } else {
                this.props.dispatch(
                  notificationActions.showNotification(
                    "Texto não encontrado nesta linha.",
                    "danger",
                  ),
                );
              }
            },
          });
        }

        if (editOperation) {
          ops.push({
            title: "Editar",
            content: (
              <EditIcon style={{ fontSize: "18px" }} nativeColor={infoColor} />
            ),
            execute: (row) =>
              this.props.dispatch(push(`${editorRoutePath}/${row.id}`)),
          });
        }

        if (openOperation) {
          ops.push({
            title: "Abrir",
            content: (
              <OpenIcon style={{ fontSize: "18px" }} nativeColor={infoColor} />
            ),
            execute: (row) =>
              this.props.dispatch(
                push(`${openRoutePath.replace(":id", row.id)}`),
              ),
          });
        }

        if (deleteOperation) {
          ops.push({
            title: "Excluir",
            content: (
              <CloseIcon
                style={{ fontSize: "18px" }}
                nativeColor={dangerColor}
              />
            ),
            execute: (row) => this.confirmDelete(row.id),
          });
        }

        if (openLinkOperation) {
          ops.push({
            title: "Abrir Link",
            content: (
              <OpenIcon style={{ fontSize: "18px" }} nativeColor={infoColor} />
            ),
            execute: (row) => {
              const url = row.url;
              if (url) {
                window.open(url, "_blank");
              } else {
                this.props.dispatch(
                  notificationActions.showNotification(
                    "URL não encontrada nesta linha.",
                    "danger",
                  ),
                );
              }
            },
          });
        }

        if (forceExecutionOperation) {
          ops.push({
            title: "Forçar Envio",
            content: (
              <SendIcon style={{ fontSize: "18px" }} nativeColor={infoColor} />
            ),
            execute: (row) =>
              this.props.dispatch(
                push(`${forceExecutionRoutePath.replace(":id", row.id)}`),
              ),
          });
        }

        if (ops.length > 0) return ops;

        if (manageOperation) {
          return [
            ...this.defaultOperations,
            {
              title: "Supervisionar",
              content: (
                <VisibilityOutlinedIcon
                  style={{ fontSize: "18px" }}
                  nativeColor={purpleColor}
                />
              ),
              // execute: id => this.props.dispatch(push(manageRoutePath.replace(':id', id))),
              execute: (row) => this.handleImpersonate(row.id),
            },
          ];
        }

        if (walletBalancingOperation) {
          return [
            ...this.defaultOperations,
            {
              title: "Balanceamento da Carteira",
              content: (
                <PieChartIcon
                  style={{ fontSize: "18px" }}
                  nativeColor={primaryColor}
                />
              ),
              execute: (row) => {
                const url = walletBalancingRoutePath.replace(":id", row.id);
                window.open(url, "_blank");
              },
            },
            {
              title: "Posição do Cliente",
              content: (
                <AccountBalanceWalletIcon
                  style={{ fontSize: "18px" }}
                  nativeColor={brownColor}
                />
              ),
              execute: (row) => {
                const url = walletPositionRoutePath.replace(":id", row.id);
                window.open(url, "_blank");
              },
            },
          ];
        }

        return this.defaultOperations;
      };

      componentWillMount() {
        this.onMount();
      }

      // fetchEntities = () => this.props.dispatch(entityActions.fetchAll());
      fetchEntities = (id = null) => {
        if (id) {
          return this.props.dispatch(entityActions.fetchAll(id));
        }
        return this.props.dispatch(entityActions.fetchAll());
      };

      updateEntity = (id, params) =>
        this.props.dispatch(entityActions.update(id, params));

      deleteEntity = (id) => this.props.dispatch(entityActions.delete(id));

      onMount = () => {
        this.props.dispatch(cacheActions.cleanCache());
        this.fetchEntities(pathId).catch(this.onFetchFail);
      };

      onFieldUpdate = (id, columnName, value) => {
        const params = { [columnName]: value };
        this.updateEntity(id, params)
          .then(this.onUpdateSucceed)
          .catch(this.onUpdateFail);
      };

      confirmDelete = (id) => {
        confirmAlert({
          title: "Confirmação de exclusão",
          message: "Deseja mesmo apagar o registro.",
          buttons: [
            {
              label: "Sim",
              onClick: () => this.onRowDelete(id),
            },
            {
              label: "Não",
              onClick: () => {},
            },
          ],
        });
      };

      handleImpersonate = async (userId) => {
        try {
          await ciApi.call({
            httpMethod: "post",
            endpoint: "impersonation/start",
            params: { impersonatedUserId: userId },
          });

          store.dispatch(authActions.fetchCurrentUser());
          store.dispatch(push("/"));
        } catch (error) {
          console.error("Erro ao iniciar personificação:", error);
          alert("Não foi possível personificar este usuário.");
        }
      };

      onRowDelete = (id) => {
        this.deleteEntity(id)
          .then(this.onDeleteSucceed)
          .catch(this.onDeleteFail);
      };

      onFetchFail = (apiResponse) => {
        const { dispatch } = this.props;
        const message = "Operação falhou. Não foi possível acessar os dados.";
        const color = "danger";
        dispatch(notificationActions.showNotification(message, color));
        dispatch(popupActions.handleApiResponse(apiResponse));
      };

      onUpdateSucceed = () => {
        const { dispatch } = this.props;
        const message =
          "Operação concluída. O dado foi atualizado com sucesso.";
        const color = "success";
        dispatch(notificationActions.showNotification(message, color));
      };

      onUpdateFail = (apiResponse) => {
        const { dispatch } = this.props;
        const message = "Operação falhou. Não foi possível atualizar o dado.";
        const color = "danger";
        dispatch(notificationActions.showNotification(message, color));
        dispatch(popupActions.handleApiResponse(apiResponse));
      };

      onDeleteSucceed = () => {
        const { dispatch } = this.props;
        const message =
          "Operação concluída. Os dados foram excluídos com sucesso.";
        const color = "success";
        dispatch(notificationActions.showNotification(message, color));
      };

      onDeleteFail = (apiResponse) => {
        const { dispatch } = this.props;
        const message = "Operação falhou. Não foi possível excluir os dados.";
        const color = "danger";
        dispatch(notificationActions.showNotification(message, color));
        dispatch(popupActions.handleApiResponse(apiResponse));
      };

      render() {
        const { entities } = this.props;
        const { id } = this.state;
        return (
          <>
            <DefaultTable
              id={id}
              dataList={entities}
              operations={this.getOperations()}
              onFieldUpdate={this.onFieldUpdate}
              {...otherProps}
            />
          </>
        );
      }
    },
  );

export default generateEntityTable;
